import { useMemo } from 'react'

import { getConfig } from '@/shared/config/quizzes'
import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useBlocker } from '@/shared/hooks/useBlocker'
import { sortByPosition } from '@/shared/lib/array/sort-by-position'
import type { BlockCondition } from '@/types/blocker'
import type { Quiz } from '@/types/quiz'

import { useGamificationDataStore } from './gamificationDataStore'

export const useQuizzesStore = () => {
  const { digitalProductId } = useDigitalProductContext()
  const config = getConfig({ digitalProductId })

  const { quizzes: quizzesRaw } = useGamificationDataStore(s =>
    s.getActiveProductData()
  )

  const { generateConditions } = useBlocker()

  const quizzes = useMemo(() => {
    const sortedQuizzes = (quizzesRaw as Quiz[]).sort(sortByPosition)

    return sortedQuizzes.map(quiz => {
      let _blockCondition: BlockCondition = {
        type: 'and',
        conditions: generateConditions(quiz)
      }

      return {
        ...quiz,
        _blockCondition
      }
    })
  }, [quizzesRaw])

  return {
    quizzes,
    config
  }
}
